import { GooglePayInfo } from './google-pay-info';
import { WalletPaymentMethodBase } from './wallet-payment-method-base';

export interface GooglePay extends GooglePayInfo, WalletPaymentMethodBase {}
